<template>
  <div class="pay">正在支付...</div>
</template>

<script>
export default {
  name: 'alipay',
  mounted() {
    const key = '__alipayinfo__'

    if (localStorage.getItem(key)) {
      const div = document.createElement('div')
      div.innerHTML = localStorage.getItem(key)
      document.body.appendChild(div)
      div.querySelector('form').submit()
      localStorage.removeItem(key)
    }
  }
}
</script>

<style scoped lang="scss">
.pay {
  text-align: center;
  padding-top: 20px;
}
</style>
